// src/components/Money.tsx
//
// The one place `cents / 100` is allowed to happen — see lib/format.ts. Every
// caller passes a `number | null` straight from the API; `null` renders as an
// explicit "not yet computed" rather than "$0.00", because a bill that has not
// been pro-rated yet has no subsidy or co-payment, and "$0.00" would claim one.
import { formatCents } from '../lib/format'

export function Money({ cents, placeholder = 'Not yet computed' }: { cents: number | null; placeholder?: string }) {
  if (cents === null) {
    return <span className="pt-tabular text-[var(--sgds-color-subtle)]">{placeholder}</span>
  }
  return <span className="pt-tabular">{formatCents(cents)}</span>
}
